import InboxRuleRequestStatus from './schema/InboxRuleRequestStatus';
import InboxRuleStore from './schema/InboxRuleStore';
import { createStore } from 'satcheljs';

const defaultInboxRuleStore: InboxRuleStore = {
    createdRule: null,
    isInboxRuleDialogShown: false,
    selectedFolderId: null,
    inboxRuleRequestStatus: InboxRuleRequestStatus.NotInitiated,
    runRuleNowChecked: false,
};

export default createStore<InboxRuleStore>('InboxRuleStore', defaultInboxRuleStore)();
